import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type UserAvailableCollectionsVariables = Types.Exact<{
  publicKey: Types.Scalars['String'];
}>;


export type UserAvailableCollections = { items: Array<(
    Pick<Types.Collection, 'id' | 'name' | 'symbol' | 'contractAddress' | 'collectionImageUrl' | 'contractType' | 'chainId'>
    & { artworkCount: { aggregate: Types.Maybe<Pick<Types.Artwork_Aggregate_Fields, 'count'>> } }
  )> };



export const UserAvailableCollectionsDocument = /*#__PURE__*/ `
    query UserAvailableCollections($publicKey: String!) {
  items: collection(
    where: {user: {publicKey: {_eq: $publicKey}}, deletedAt: {_is_null: true}, hiddenAt: {_is_null: true}, contractType: {_eq: "FND_COLLECTION"}, contractStandard: {_neq: "ERC1155"}}
    order_by: {createdAt: desc}
  ) {
    id
    name
    symbol
    contractAddress
    collectionImageUrl
    contractType
    chainId
    artworkCount: artworks_aggregate(
      where: {isIndexed: {_eq: true}, status: {_eq: "MINTED"}, deletedAt: {_is_null: true}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

export const useUserAvailableCollections = <
      TData = UserAvailableCollections,
      TError = ClientError
    >(
      variables: UserAvailableCollectionsVariables,
      options?: Omit<UseQueryOptions<UserAvailableCollections, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserAvailableCollections, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UserAvailableCollections, TError, TData>(
      {
    queryKey: ['UserAvailableCollections', variables],
    queryFn: hasuraFetcher<UserAvailableCollections, UserAvailableCollectionsVariables>(UserAvailableCollectionsDocument, variables),
    ...options
  }
    )};

useUserAvailableCollections.getKey = (variables: UserAvailableCollectionsVariables) => ['UserAvailableCollections', variables];

export const useInfiniteUserAvailableCollections = <
      TData = InfiniteData<UserAvailableCollections>,
      TError = ClientError
    >(
      variables: UserAvailableCollectionsVariables,
      options: Omit<UseInfiniteQueryOptions<UserAvailableCollections, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserAvailableCollections, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserAvailableCollections, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['UserAvailableCollections.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<UserAvailableCollections, UserAvailableCollectionsVariables>(UserAvailableCollectionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserAvailableCollections.getKey = (variables: UserAvailableCollectionsVariables) => ['UserAvailableCollections.infinite', variables];


useUserAvailableCollections.fetcher = (variables: UserAvailableCollectionsVariables, options?: RequestInit['headers']) => hasuraFetcher<UserAvailableCollections, UserAvailableCollectionsVariables>(UserAvailableCollectionsDocument, variables, options);
